<template>
  <!-- content start -->
  <div
    :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }"
    class="content"
    style="padding-top: 0px !important;"
  >
    <!-- <TriviaHeader /> -->
    <header-o :model="headerData"></header-o>
    <div
      :style="{
        minHeight: '100vh'
      }"
      class=""
      style="margin-left: 15px;margin-right: 15px; margin-top: -175px"
    >
      <div
        v-for="(item, index) in quizzes"
        :key="item.id"
        v-if="quizzes.length > 0"
      >
        <TriviaListCard :quiz_data="item" @quizend="removeQuiz(item)" />
      </div>
      <div
        v-if="quizzes.length === 0"
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#eeeeee',
          borderRadius: '10px'
        }"
        class="no-quiz  align-ver center-hor bg-light"
      >
        <div
          style="display: flex; justify-content: center; align-items: center; width: 100%"
        >
          <img src="@/assets/no-data.svg" class="w20" style="width: 25%;" />
        </div>
        <div style="font-size: 16px; font-weight: 800; margin-top: 20px;">
          No Data Found
        </div>
      </div>
    </div>
  </div>
  <!-- content end -->
</template>

<script>
import Quiz from "@/components/quiz-list-card";
import SurveyHeader from "../components/survey-header.vue";
import axios from "axios";
import TriviaHeader from "../components/trivia-header.vue";
import TriviaListCard from "../components/trivia-list-card.vue";
import OverlapHeader from "@/components/overlapped-header";
export default {
  name: "trivia-zone",
  props: {
    showAddTask: Boolean
  },
  components: {
    TriviaListCard,
    TriviaHeader,
    "header-o": OverlapHeader
  },
  data() {
    return {
      quizDetails: [],
      quizzes: [],
      is_shimmer: true,
      headerData: {
        onlyHeader: true
      }
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    }
  },
  methods: {
    showShimmer: function() {
      return this.is_shimmer;
    },
    fetchQuiz() {
      var self = this;
      var url = self.$store.getters.flyyDomain + "/v1/trivias";
      var headers = self.$store.getters.headers;
      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            // console.log(data)
            self.quizzes = data.trivias;
            this.is_shimmer = false;
            if (self.quizzes.length === 0) {
              this.is_shimmer = true;
            }
          } else {
            if (self.quizzes.length === 0) {
              this.is_shimmer = false;
            }
            console.log("Error fetching the Quiz list");
          }
        });
    },
    removeQuiz(item) {
      this.quizzes = this.quizzes.filter(currentitem => {
        if (currentitem.id != item.id) {
          return currentitem;
        }
        return;
      });
      // console.log("this.quizzes==>",this.quizzes);
    }
  },
  created() {
    this.$store.state.headTitle = "Trivia";
    // this.$emit('handleHideFooter');
    this.$store.state.showHeader = false;
    this.fetchQuiz();
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = true;
    this.$store.state.quizDetailsTitle = "Quiz";
  }
};
</script>
<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";

.no-quiz {
  text-align: center;
  background: #ffffff;
  padding: 1rem;
  height: 80vh;
  border-radius: 5px;
}
.no-quiz img {
  padding-top: 70px;
  width: 60%;
}
</style>
